import React from 'react';
import { Link } from 'react-router-dom';

import { Button } from '@mui/material';

import LogoIcon from 'assets/img/logo-small.svg';

import HomeIcon from './assets/home.svg';
import useStyles from './styles';

interface BaseProps {
    className?: string;
}

interface ErrorPageProps extends BaseProps {
    status: string | number;
    description?: React.ReactNode;
}

const ErrorPage: React.FC<ErrorPageProps> & { NotFound: React.FC<BaseProps> } = ({
    status,
    description,
    className
}) => {
    const { classes, cx } = useStyles();

    return (
        <div className={cx(classes.root, className)}>
            <LogoIcon className={classes.icon} />
            <div className={classes.text}>
                <h1 className={classes.title}>{status}</h1>
                <p className={classes.description}>{description}</p>
            </div>
            <Button
                variant="contained"
                component={Link}
                to="/"
                startIcon={<HomeIcon />}
                className={classes.button}
                disableElevation
                centerRipple
                disableFocusRipple
            >
                {'Go back home'}
            </Button>
        </div>
    );
};

ErrorPage.NotFound = function NotFound(props) {
    return (
        <ErrorPage
            {...props}
            status="Page not found"
            description={
                <>
                    {"The page you are looking for doesn't"}
                    <br />
                    {'exist or has been moved'}
                </>
            }
        />
    );
};

export default ErrorPage;
